import React from "react";
import { Link } from "react-router-dom";

type HeroSectionProps = {
  title: React.ReactNode;
  subtitle: string;
  buttonText: string;
  buttonLink: string;
  image: string;
  imageAlt?: string;
};

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  buttonText,
  buttonLink,
  image,
  imageAlt = "Hero Banner",
}) => {
  return (
    <section className="xb-hero-section pt-120 pb-60">
      <div className="container">
        <div className="row align-items-center">
          
          {/* LEFT CONTENT */}
          <div
            className="col-lg-6 col-md-12 wow fadeInLeft"
            data-wow-delay="100ms"
          >
            <h1 className="xb-hero-title mt-20">
              {title}
            </h1>

            <p className="xb-hero-subtext mt-20">
              {subtitle}
            </p>

            <div className="mt-30">
              <Link to={buttonLink} className="xb-btn">
                {buttonText}
              </Link>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div
            className="col-lg-6 col-md-12 text-center wow fadeInRight"
            data-wow-delay="200ms"
          >
            <img src={image} alt={imageAlt} className="xb-hero-img" />
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
